// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getOrderNumbers ( ) {

    const endPoint = `${basePath}/order-numbers`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getOrderInformation ( orderNumber ) {

    const endPoint = `${basePath}/order-information`;
    const payLoad = {
        orderNumber
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getTransInformation ( orderNumber, transNumber ) {

    const endPoint = `${basePath}/trans-information`;
    const payLoad = {
        orderNumber,
        transNumber
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
